// import { ReactNode } from 'react';

// interface AppShellProps {
//   children: ReactNode;
// }

// export const AppShell = ({ children }: AppShellProps) => {
//   return (
//     <div className='min-h-screen bg-background flex flex-colmx-auto relative'>
//       {/* <main className='flex-1 pb-[calc(var(--tab-bar-height)+var(--safe-area-bottom))]'> */}
//       {children}
//       {/* </main> */}
//     </div>
//   );
// };

/**
 * AppShell Component
 * Provides safe area padding for iOS PWA/WebApp mode where content
 * can be cut off by the notch (top) and home indicator (bottom).
 *
 * Uses env(safe-area-inset-*) CSS values which are only non-zero
 * when the app is running as an installed PWA with viewport-fit=cover.
 *
 * Wrap any full-screen layout with this component to ensure proper
 * padding on iOS devices.
 */

import { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
}

export const AppShell = ({ children }: AppShellProps) => {
  return (
    <div
      className='min-h-screen bg-background flex flex-col'
      style={{
        paddingTop: 'calc(env(safe-area-inset-top) / 50)', // Reduce top padding to 1/50th to avoid excessive spacing from notch
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      {children}
    </div>
  );
};
